module.exports = __webpack_public_path__ + "fonts/SFCompactDisplay-Heavy.8f5dcf2.otf";